import React, { useState, useRef, useEffect } from "react";
import makeStyles from '@mui/styles/makeStyles';
import FadeLoader from "react-spinners/FadeLoader";

import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
} from "@mui/material";

//import ReactExport from "react-data-export";
import { Button } from "reactstrap";

import MaterialTable from "@material-table/core";
import * as Service from "../../../services/Service.js";

// Highcharts component
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { parse } from "date-fns";



const useStyles = makeStyles((theme) => ({
  pageSet: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  whiteBG: {
    padding: "1rem",
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    color: "#111",
  },
  fullWidth: {
    width: "95%",
  },
}));

const Reports = (props) => {
  const classes = useStyles();
  const tableRef = useRef();
  let [loading, setLoading] = useState(true);
  let [excelDisable, setExcelDisable] = useState(true);
  let [color, setColor] = useState("#111");
  const [selectedRow, setSelectedRow] = useState(null);
  const [numberRowPerPage, setNumberRowPerPage] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRow, setTotalRow] = useState(0);
  const [provinceList, setProvinceList] = useState([]);
  const [bczList, setBczList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [reportList, setReportList] = useState([]);
  const [reportChartList, setReportChartList] = useState([]);
  const [excelReportList, setExcelReportList] = useState([]);
  const [graphProduct, setGraphProduct] = useState([]);
  const [dataSet, setDataSet] = useState([]);
  const [graphBalance, setGraphBalance] = useState([]);
  const [state, setState] = useState({
    province: "ALL",
    bcz: "ALL",
    month: "0",
    year: "0",
  });



  const optionThree = {
    chart: {
      type: "bar",
      height: graphProduct.length>60? window.screen.availHeight+2700:window.screen.availHeight+300,
    },
    title: {
      text: "Stock Status Report",
    },
    xAxis: {
      categories: graphProduct ? graphProduct : null,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Balance",
      },
    },
    legend: {
      reversed: true,
    },
    plotOptions: {
      series: {
        stacking: "normal",
      },
    },
    series: [
      {
        name: "Balance",
        data: graphBalance ? graphBalance : null,
      },
    ],
  };

  const handleChangePage = (data) => {
    setPageNumber(data);
  };
  const handleChangeRowPerPage = (data) => {
    setNumberRowPerPage(data);
  };

  const handleFilter = (e, v) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const fetchProvinceFilter = () => {
   
  };
  const fetchBczFilter = () => {
   
  };
  const fetchMonthFilter = async () => {
  
  };
  const fetchYearFilter = async () => {
  
  };
  const fetchData = async () => {
 
  };




  const fetchGraphData = () => {
  
  };

  useEffect(() => {
  
  }, [reportChartList]);

  useEffect(() => {
    if (
      state.province &&
      state.bcz &&
      state.year !== "0" &&
      state.month !== "0"
    ) {
      fetchData();
      fetchGraphData();
      // fetchAllExcelData();
    }
  }, [state.province, state.bcz, state.month, state.year]);

  useEffect(() => {
    if (yearList.length > 0) {
      setState({ ...state, year: yearList[0].Year });
    }
    if (monthList.length > 0) {
      setState({ ...state, month: monthList[0].MonthName });
    }
  }, [monthList, yearList]);

  React.useEffect(() => {
    fetchProvinceFilter();
    fetchBczFilter();
    fetchMonthFilter();
    fetchYearFilter();
  }, []);

  React.useEffect(() => {
    if (yearList.length > 0) {
      setState({ ...state, year: yearList[0].Year });
    }
  }, [yearList]);

  React.useEffect(() => {
    if (yearList.length > 0) {
      setState({ ...state, year: yearList[0].Year });
    }
  }, [yearList]);

  React.useEffect(() => {
    if (pageNumber > 0) {
      fetchData();
    }
  }, [pageNumber]);

  return (
    <>
      {loading ? (
        <div className="loader-div">
          {/* <CircularProgress color="info" className="loader" /> */}
          <FadeLoader
            color={color}
            loading={loading}
            css={{ top: "50%", left: "50%" }}
            size={250}
          />
        </div>
      ) : null}
      <div className={classes.pageSet}>
        <div className={classes.whiteBG}>
          <div className="text-center">
            <h3>Report</h3>
          </div>

          <div className="row mt-4">
            <div className="col-md-7 col-sm-3 pad-1">
              <div className="row mb-5">
                <div className="col-md-3">
                  <FormControl variant="standard" className={classes.fullWidth}>
                    <InputLabel id="demo-simple-select-helper-label">
                      Province
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      name="province"
                      value={state.province || ""}
                      fullWidth
                      onChange={(e) => handleFilter(e)}
                    label="Province">
                      <MenuItem value={"ALL"}>ALL</MenuItem>
                      {provinceList.map((row, index) => {
                        return (
                          <MenuItem key={index} value={row.ProvinceName}>
                            {row.ProvinceName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <FormControl variant="standard" className={classes.fullWidth}>
                    <InputLabel id="demo-simple-select-helper-label">
                      BCZ
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      name="bcz"
                      value={state.bcz || ""}
                      fullWidth
                      onChange={(e) => handleFilter(e)}
                    label="BCZ">
                      <MenuItem value={"ALL"}>ALL</MenuItem>
                      {bczList.map((row, index) => {
                        return (
                          <MenuItem key={index} value={row.BCZName}>
                            {row.BCZName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <FormControl variant="standard" className={classes.fullWidth}>
                    <InputLabel id="demo-simple-select-helper-label">
                      Month
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      name="month"
                      value={state.month || ""}
                      fullWidth
                      onChange={(e) => handleFilter(e)}
                    label="Month">
                      {monthList.map((row, index) => {
                        return (
                          <MenuItem key={index} value={row.MonthName}>
                            {row.MonthName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-3">
                  <FormControl variant="standard" className={classes.fullWidth}>
                    <InputLabel id="demo-simple-select-helper-label">
                      Year
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      name="year"
                      value={state.year || ""}
                      fullWidth
                      onChange={(e) => handleFilter(e)}
                    label="Year">
                      {yearList.map((row, index) => {
                        return (
                          <MenuItem key={index} value={row.Year}>
                            {row.Year}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <MaterialTable
                tableRef={tableRef}
                title={"Report"}
                icons={Service.default.tableicons()}
                columns={[
                  { title: "Province", field: "ProvinceName" },
                  { title: "BCZ", field: "BCZName" },
                  { title: "Facility", field: "FacilityName" },
                  { title: "Product", field: "ProductName" },
                  { title: "Balance", field: "ClosingStock" },
                  { title: "AMC", field: "AMC" },
                  { title: "MOS", field: "MOS" },
                ]}
                data={reportList}
                components={{
                  Pagination: (props) => (
                    <TablePagination
                      {...props}
                      rowsPerPageOptions={[20]}
                      rowsPerPage={numberRowPerPage}
                      count={totalRow}
                      page={pageNumber}
                      onPageChange={(e, page) => {
                        handleChangePage(page);
                      }}
                      onRowsPerPageChange={(event) => {
                        props.onChangeRowsPerPage(event);
                        handleChangeRowPerPage(event.target.value);
                      }}
                    />
                  ),
                }}
                options={{
                  showTitle: false,
                  toolbar: false,
                  rowStyle: (rowData) => ({
                    backgroundColor:
                      selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
                  }),
                  headerStyle: {
                    position: "sticky",
                    fontWeight: "bold",
                    border: "0.5px solid lightgrey",
                    zIndex: "0",
                  },
                  sorting: true,
                  search: false,
                  pageSize: 20,
                  // pageSizeOptions: [6],
                }}
              />
            </div>
            <div className="col-md-5 col-sm-3 pad-1 pt-6">
              <HighchartsReact highcharts={Highcharts} options={optionThree} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;
